import { render, staticRenderFns } from "./chat-message.vue?vue&type=template&id=11e6292a&scoped=true"
import script from "./chat-message.vue?vue&type=script&lang=js"
export * from "./chat-message.vue?vue&type=script&lang=js"
import style0 from "./chat-message.vue?vue&type=style&index=0&id=11e6292a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e6292a",
  null
  
)

export default component.exports